export default "__VITE_ASSET__f0f6462b__"